import { RecordContextProvider, useRecordContext } from 'react-admin';
import { CardTable } from 'shared/mui/Card/CardTableNew/CardTable';
import { TableRowWrapper } from 'shared/mui/Table/TableRowWrapperNew/TableRowWrapper';
import { DateField, FunctionField, TextField } from 'shared/react-admin/Fields';
import { BankOperation } from 'types/embedded/bankOperation';
import { formatCurrency } from 'utils';

export const RequestsBankOpsShowTabsRelated: React.FC = () => {
  const record = useRecordContext<BankOperation>();

  if (!record?.related) {
    return null;
  }

  return (
    <RecordContextProvider value={record.related}>
      <CardTable tableBodyProps={{ sx: { '& td': { width: '208px' } } }}>
        <TableRowWrapper label="Провайдер">
          <TextField source="provider.name" />
        </TableRowWrapper>
        <TableRowWrapper label="Направление">
          <TextField source="direction.description" />
        </TableRowWrapper>
        <TableRowWrapper label="Тип банковской операции">
          <TextField source="type.description" sx={{ wordBreak: 'keep-all' }} />
        </TableRowWrapper>
        <TableRowWrapper label="Счет мерчанта">
          <TextField source="merchantAccount.name" />
        </TableRowWrapper>
        <TableRowWrapper label="Сумма">
          <FunctionField
            render={({ amountPenny }: BankOperation) => formatCurrency(Number(amountPenny))}
            sx={{ fontWeight: 500 }}
          />
        </TableRowWrapper>
        <TableRowWrapper label="Валюта">
          <FunctionField
            render={({ currency }: BankOperation) => `${currency?.alphaCode}, ${currency?.name}`}
            sx={{ fontWeight: 500 }}
          />
        </TableRowWrapper>
        <TableRowWrapper label="Дата в ПС">
          <DateField source="dateOfOperation" />
        </TableRowWrapper>
      </CardTable>
    </RecordContextProvider>
  );
};
